import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.disabled = false
    if (this.element.dataset.originalMsg) {
      this.element.innerHTML = this.element.dataset.originalMsg
    }
  }
}
